import Board from "./Board";


function App() {
  return (
      <Board />
  );
}

export default App;
